import { ArrowDown, ArrowLeft, ArrowRight, ArrowUp, Crosshair } from '@phosphor-icons/react';

import styles from './DPad.module.css';

interface Props {
  onNudge: (dx: number, dy: number) => void;
  onRecentre: () => void;
  disabled?: boolean;
}

/** Nudge step in stage px, per the handoff. */
export const NUDGE_PX = 4;

/** Four nudge buttons around a recentre button. */
export function DPad({ onNudge, onRecentre, disabled = false }: Props): React.JSX.Element {
  return (
    <div className={styles.wrap}>
      <div className={styles.pad}>
        <span />
        <button
          className="btn btn-secondary"
          type="button"
          onClick={() => onNudge(0, -NUDGE_PX)}
          aria-label="Nudge up"
          disabled={disabled}
        >
          <ArrowUp size={15} weight="regular" />
        </button>
        <span />

        <button
          className="btn btn-secondary"
          type="button"
          onClick={() => onNudge(-NUDGE_PX, 0)}
          aria-label="Nudge left"
          disabled={disabled}
        >
          <ArrowLeft size={15} weight="regular" />
        </button>
        <button
          className={`btn btn-secondary ${styles.recentre}`}
          type="button"
          onClick={onRecentre}
          aria-label="Recentre the board"
          disabled={disabled}
        >
          <Crosshair size={15} weight="regular" />
        </button>
        <button
          className="btn btn-secondary"
          type="button"
          onClick={() => onNudge(NUDGE_PX, 0)}
          aria-label="Nudge right"
          disabled={disabled}
        >
          <ArrowRight size={15} weight="regular" />
        </button>

        <span />
        <button
          className="btn btn-secondary"
          type="button"
          onClick={() => onNudge(0, NUDGE_PX)}
          aria-label="Nudge down"
          disabled={disabled}
        >
          <ArrowDown size={15} weight="regular" />
        </button>
        <span />
      </div>
      <p className={styles.hint}>turn the dial · ◎ recentres</p>
    </div>
  );
}
